import { render, staticRenderFns } from "./Dasbor.vue?vue&type=template&id=f7aebdb0&scoped=true&"
import script from "./Dasbor.vue?vue&type=script&lang=js&"
export * from "./Dasbor.vue?vue&type=script&lang=js&"
import style0 from "./Dasbor.vue?vue&type=style&index=0&id=f7aebdb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7aebdb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFabTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VBtn,VContainer,VFabTransition,VIcon,VMain})
